module.exports = __webpack_public_path__ + "media/images/star_icon_100-06a6ec55e10f360b3c653bc70d3a63e9.svg";